module.exports = __webpack_public_path__ + "img/安全存储.ba605a3a.png";